import React from 'react';
import Modal from '../../../../../../Components/Modal/Modal';
import { NCZIPreferredHealthProfessional } from '../../../../Interfaces/ncziPatientInformations';
import NCZIEditPreferredHealthProfessionalForm from './NCZIEditPreferredHealthProfessionalForm';

interface Props {
	opened: boolean;
	onClose: (needReload: boolean) => void;
	patientIdentifier: string;
	preferredHealthProfessional?: NCZIPreferredHealthProfessional;
}

const NCZIEditPreferredHealthProfessionalModal: React.FC<Props> = props => {
	const { opened, onClose, preferredHealthProfessional, patientIdentifier } =
		props;

	return (
		<Modal opened={opened} onClose={() => onClose(false)} fullScreen={false}>
			<Modal.Header
				title={
					preferredHealthProfessional ? 'base.shared.edit' : 'base.shared.add'
				}
			/>
			<Modal.Content>
				<NCZIEditPreferredHealthProfessionalForm
					onClose={onClose}
					preferredHealthProfessional={preferredHealthProfessional}
					patientIdentifier={patientIdentifier}
				/>
			</Modal.Content>
		</Modal>
	);
};

export default NCZIEditPreferredHealthProfessionalModal;
